"use strict";

module.exports = /* @ngInject */["$scope", "$route", function ($scope, $route) {
  // pass variables:
  ['directive', 'directiveAttributes'].forEach(function (variableName) {
    $scope[variableName] = $route.current.$$route[variableName];
  });
  $scope.includeNavBar = $route.current.$$route.includeNavBar;
}];